/* eslint-disable */
import {Pressable, StyleSheet, Text, View} from 'react-native';
import {useTranslation} from 'react-i18next';
import {colors, radii, spacing, typography} from '../../config/theme';

// Back arrow + screen title + "STEP x OF y" + progress bar.
// Used on onboarding screens 2-4.
const StepHeader = ({title, step, total = 4, onBack}) => {
  const {t} = useTranslation();
  const percent = Math.round((step / total) * 100);

  return (
    <View style={styles.wrap}>
      <View style={styles.topRow}>
        <Pressable onPress={onBack} hitSlop={12} style={styles.back}>
          <Text style={styles.backIcon}>←</Text>
        </Pressable>
        <Text style={styles.title}>{title}</Text>
      </View>

      <View style={styles.progressRow}>
        <View style={styles.stepPill}>
          <Text style={styles.stepText}>
            {t('onboarding.step', 'STEP {{step}} OF {{total}}', {step, total})}
          </Text>
        </View>
        <Text style={styles.percent}>
          {t('onboarding.completed', '{{percent}}% COMPLETED', {percent})}
        </Text>
      </View>

      <View style={styles.track}>
        <View style={[styles.fill, {width: `${percent}%`}]} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: {
    paddingHorizontal: spacing.margin,
    paddingTop: spacing.sm,
    gap: spacing.md,
  },
  topRow: {flexDirection: 'row', alignItems: 'center', gap: spacing.md},
  back: {paddingRight: spacing.xs},
  backIcon: {...typography.headlineLg, color: colors.primary},
  title: {...typography.headlineSm, color: colors.primary},

  progressRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  stepPill: {
    backgroundColor: colors.mintSoft,
    borderRadius: radii.pill,
    paddingHorizontal: spacing.sm + 2,
    paddingVertical: spacing.xs,
  },
  stepText: {...typography.labelSm, color: colors.primary},
  percent: {...typography.labelSm, color: colors.secondary},

  track: {
    height: 6,
    borderRadius: radii.pill,
    backgroundColor: colors.border,
    overflow: 'hidden',
  },
  fill: {
    height: '100%',
    borderRadius: radii.pill,
    backgroundColor: colors.primary,
  },
});

export default StepHeader;